var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"vegaContain",attrs:{"id":_vm.id,"element-loading-text":"数据统计中...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }